import $ from "jquery";

import {getCurrentMaterial} from "./eternalScrollOnReadyHandlers";

export const scrollToComments = () => {
    $(document).ready(function () {
        if (document.location.hash === "#comments") {
            window.scroll(0, $('#comment-list').offset().top - window.screen.height / 3);
        }
    });

    $(document).on('click', '.material-content-info__comments', () => {
        const currentMaterial = getCurrentMaterial();

        document.location.hash = "#comments";
        window.scroll(0, currentMaterial.find('.comment-replies').offset().top - window.screen.height / 3);
    });
};
